
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2022/04/website-traffic-prediction",
      function () {
        return require("private-next-pages/blog-post/2022/04/website-traffic-prediction.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2022/04/website-traffic-prediction"])
      });
    }
  